import { match } from 'ts-pattern';
import { Platform } from '~/screens/AddTalent/constants';

export const getPlatformKey = (platform: Platform) => {
  return match(platform)
    .with('instagram', () => 'igHandle')
    .with('snapchat', () => 'snapHandle')
    .with('youtube', () => 'ytHandle')
    .with('tiktok', () => 'ttHandle')
    .exhaustive();
};
